import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';

interface TimelineEntry {
  date: string;
  hour: number;
  total: number;
  completed: number;
  failed: number;
}

interface TimelineChartProps {
  data: TimelineEntry[];
}

const TimelineChart: React.FC<TimelineChartProps> = ({ data }) => {
  if (data.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>시간대별 처리량 추이</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-center text-gray-500 py-8">데이터가 없습니다.</p>
        </CardContent>
      </Card>
    );
  }

  const maxTotal = Math.max(...data.map((d) => d.total), 1);

  return (
    <Card>
      <CardHeader>
        <CardTitle>시간대별 처리량 추이 (최근 24시간)</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-end gap-1 h-40 overflow-x-auto pb-6 relative">
          {data.map((entry, idx) => {
            const completedHeight = (entry.completed / maxTotal) * 100;
            const failedHeight = (entry.failed / maxTotal) * 100;
            return (
              <div
                key={idx}
                className="flex-shrink-0 flex flex-col items-center"
                style={{ minWidth: '28px' }}
                title={`${entry.date} ${entry.hour}시 - 완료: ${entry.completed}, 실패: ${entry.failed}`}
              >
                <div className="flex flex-col-reverse w-5" style={{ height: '120px' }}>
                  <div
                    className="bg-green-500 rounded-t-sm transition-all"
                    style={{ height: `${completedHeight}%` }}
                  />
                  <div
                    className="bg-red-400 rounded-t-sm transition-all"
                    style={{ height: `${failedHeight}%` }}
                  />
                </div>
                <span className="text-xs text-gray-400 mt-1">{entry.hour}</span>
              </div>
            );
          })}
        </div>
        <div className="flex items-center gap-4 mt-2 text-xs text-gray-500">
          <div className="flex items-center gap-1">
            <div className="w-3 h-3 bg-green-500 rounded-sm" />
            <span>완료</span>
          </div>
          <div className="flex items-center gap-1">
            <div className="w-3 h-3 bg-red-400 rounded-sm" />
            <span>실패</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default TimelineChart;
